'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Button = require('@narvar/nth-block-button');
var TextArea = require('@narvar/nth-block-text-area');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
require('../../../components/SelectList/SelectList.js');
require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var useLanguage = require('../../../hooks/language/useLanguage.js');
var language_en_US = require('../../../consts/language_en_US.js');
var ReturnReasonsComments_module = require('./ReturnReasonsComments.module.css.js');
var Checkbox = require('@narvar/nth-block-checkbox');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextArea__default = /*#__PURE__*/_interopDefaultLegacy(TextArea);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);

const tempLanguageKeys = {
  returnsReasonsCommentsPlaceholderRequired: language_en_US["default"].returnsReasonsCommentsPlaceholderRequired
};
const ReturnReasonsComments = _ref => {
  let {
    onChange,
    customerComments,
    required,
    attestation,
    attested,
    hideSubmit,
    onSubmit
  } = _ref;
  const {
    returnsReasonsCommentsTitle,
    returnsReasonsCommentsPlaceholder,
    returnsActionsNext
  } = nthHookTranslations.useTranslations();
  const {
    returnsReasonsCommentsPlaceholderRequired
  } = tempLanguageKeys;
  const [elId] = React.useState(`customer-comment-${Math.random()}`);
  const handleCommentChange = event => {
    onChange({
      customerComments: event.target.value,
      attested
    });
  };
  const handleAttestedChange = event => {
    onChange({
      customerComments: customerComments,
      attested: event.target.checked
    });
  };
  const handleSubmit = () => {
    onSubmit();
  };
  const {
    rawValue: returnsReasonsCommentsPlaceholderRaw
  } = useLanguage["default"]({
    langKey: 'returnsReasonsCommentsPlaceholder'
  });
  const requiredPlaceholder = useLanguage["default"]({
    langKey: 'returnsReasonsCommentsPlaceholderRequired',
    defaultString: returnsReasonsCommentsPlaceholderRequired
  }).rawValue;
  const textAreaLabel = required ? requiredPlaceholder : returnsReasonsCommentsPlaceholder ?? returnsReasonsCommentsPlaceholderRaw;
  const isValid = (!required || customerComments.length > 0) && (!attestation || attested);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsCommentsTitle",
    defaultString: returnsReasonsCommentsTitle
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: ReturnReasonsComments_module["default"].commentWrapper
  }, attestation && /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    checked: attested,
    id: "attestationCheckbox",
    onChange: handleAttestedChange
  }, attestation), /*#__PURE__*/React__default["default"].createElement(TextArea__default["default"], {
    className: ReturnReasonsComments_module["default"].textarea,
    id: elId,
    onChange: handleCommentChange,
    value: customerComments,
    placeholder: textAreaLabel
  })), !hideSubmit && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: !isValid,
    onClick: handleSubmit
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsActionsNext",
    defaultString: returnsActionsNext
  })));
};

exports["default"] = ReturnReasonsComments;
